<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-up-small">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M18.4203 15.8537C18.225 16.049 17.9084 16.049 17.7132 15.8537L12.4001 10.5406L7.08695 15.8537C6.89169 16.049 6.57511 16.049 6.37985 15.8537C6.18458 15.6585 6.18458 15.3419 6.37985 15.1466L12.0465 9.47994C12.2418 9.28468 12.5584 9.28468 12.7536 9.47994L18.4203 15.1466C18.6155 15.3419 18.6155 15.6585 18.4203 15.8537Z" fill="#212328"/>
</g>
</svg>
